import { connect } from 'react-redux';
import { createSubscriptionPlan, resetSubscriptions } from '../store/subscriptionsSlice';
import SubscriptionConfirmation from './Confirmation';

const mapDispatch = {
  createSubscriptionPlan,
  resetSubscriptions,
};

export default connect(null, mapDispatch)(SubscriptionConfirmation);
